<div class="master-modal reviepw_items_modal" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <!-- Modal-Header -->
      <div class="modal-header">
        <h4 class="modal-title">{{data.request_description}}</h4>
        <div class="modal_close_btn">
          <span (click)="dialogClose()" class="modal-close"><i class="material-icons">close</i></span>
        </div>
      </div>
      <!-- Modal content-->
      <form class="form-section" [formGroup]="masterRequestsForm" (ngSubmit)="addMasterRequests()">
        <perfect-scrollbar class="modal-body-scrollbar">
          <div mat-dialog-content>
            <!-- Modal-Body -->
            <div class="modal-body">
                <!-- Name-INPUT -->
                <div class="custom-form-group">
                  <label class="custom-label" for="">Name<span class="star">*</span></label>
                  <div class="custom-form-control">
                    <mat-form-field appearance="outline">
                      <input matInput placeholder="Enter Name" formControlName="name">
                      <mat-error *ngIf="name.invalid && ( name.dirty || name.touched )">
                        <span>Please provide a valid value</span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
            </div>
          </div>
        </perfect-scrollbar>
        <!-- Modal-Footer -->
        <div class="modal-footer">
          <div mat-dialog-actions class="modal_footer">
            <button mat-button (click)="dialogClose()" class="modal-cancel-btn modal-footer-btn">
              <span>Cancel</span>
            </button>
            <button mat-button class="modal-save-btn global-btn modal-footer-btn">
              <span>Save</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
